import React from "react";
import { interpolate, useCurrentFrame, useVideoConfig } from "remotion";

const BLOBS = [
  {
    startX: 80,
    endX: 140,
    startY: 120,
    endY: 200,
    size: 420,
    color: "rgba(255,183,213,0.55)",
    phase: 0,
  },
  {
    startX: 600,
    endX: 500,
    startY: 80,
    endY: 200,
    size: 500,
    color: "rgba(200,164,255,0.45)",
    phase: 40,
  },
  {
    startX: 200,
    endX: 320,
    startY: 700,
    endY: 600,
    size: 460,
    color: "rgba(160,231,255,0.45)",
    phase: 80,
  },
  {
    startX: 700,
    endX: 620,
    startY: 500,
    endY: 650,
    size: 380,
    color: "rgba(255,228,160,0.50)",
    phase: 20,
  },
  {
    startX: 400,
    endX: 480,
    startY: 300,
    endY: 380,
    size: 350,
    color: "rgba(255,183,213,0.35)",
    phase: 60,
  },
  {
    startX: 100,
    endX: 180,
    startY: 1400,
    endY: 1300,
    size: 440,
    color: "rgba(200,164,255,0.40)",
    phase: 100,
  },
];

const SPARKLES = [
  { top: "8%", left: "15%", delay: 0 },
  { top: "14%", left: "75%", delay: 18 },
  { top: "28%", left: "88%", delay: 36 },
  { top: "45%", left: "5%", delay: 12 },
  { top: "55%", left: "60%", delay: 48 },
  { top: "68%", left: "30%", delay: 24 },
  { top: "80%", left: "80%", delay: 6 },
  { top: "92%", left: "45%", delay: 42 },
];

export const PastelBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width,
        height,
        backgroundColor: "#fff0f9",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      {/* Morphing blob shapes */}
      {BLOBS.map((blob, i) => {
        const cycleFrame = (frame + blob.phase) % 200;

        const x = interpolate(
          cycleFrame,
          [0, 100, 200],
          [blob.startX, blob.endX, blob.startX],
          {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          },
        );

        const y = interpolate(
          cycleFrame,
          [0, 100, 200],
          [blob.startY, blob.endY, blob.startY],
          {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          },
        );

        const opacityPulse = interpolate(
          cycleFrame,
          [0, 50, 100, 150, 200],
          [0.7, 1.0, 0.75, 1.0, 0.7],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp" },
        );

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: x,
              top: y,
              width: blob.size,
              height: blob.size,
              borderRadius: "50%",
              background: blob.color,
              filter: "blur(80px)",
              opacity: opacityPulse,
              transform: "translate(-50%, -50%)",
            }}
          />
        );
      })}

      {/* Floating sparkle stars */}
      {SPARKLES.map((sparkle, i) => {
        const cycleFrame = (frame + sparkle.delay) % 120;

        const floatY = interpolate(cycleFrame, [0, 60, 120], [0, -18, 0], {
          extrapolateLeft: "clamp",
          extrapolateRight: "clamp",
        });

        const sparkleOpacity = interpolate(
          cycleFrame,
          [0, 30, 60, 90, 120],
          [0.4, 1.0, 0.5, 1.0, 0.4],
          {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          },
        );

        const sparkleScale = interpolate(
          cycleFrame,
          [0, 60, 120],
          [0.8, 1.3, 0.8],
          {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          },
        );

        return (
          <span
            key={i}
            style={{
              position: "absolute",
              top: sparkle.top,
              left: sparkle.left,
              fontSize: "22px",
              opacity: sparkleOpacity,
              transform: `translateY(${floatY}px) scale(${sparkleScale})`,
              userSelect: "none",
              pointerEvents: "none",
            }}
          >
            ✦
          </span>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
